import React, {Component} from "react";

var Check = require('react-checkbox-group');
var Checkbox = Check.Checkbox;
var CheckboxGroup = Check.CheckboxGroup;

class ToolbarMenuItems extends Component {
  // To get all selected value including children groups
  getCheckedValues = () => {
    let val = [];
    for (var key in this.refs) {
      if(key === 'menuGroup') {
        val = val.concat(this.refs.menuGroup.getValue());
      } else if(key.indexOf('menuSettings') === 0) {
        val = val.concat(this.refs[key].getCheckedValues())
      }
    }
    return val.filter(val => val)
  }

  // To check all elements are checked
  isAllChecked = () => {
    let count = 0;
    this.props.menus.map((menu, key) => {
      let isGroup = menu.children && menu.children.length > 0;
      if(isGroup && this.refs[menu.groupId].checked) {
        count++
      }
    });
    count += this.state.value? this.state.value.filter(value => !!value).length: 0;
    return count === this.props.menus.filter(menu => menu.type != 'divider').length;
  }

  // To mark all element checked including children groups
  checkAll = () => {
    this.state.value = this.props.menus.map(a => {
      let isGroup = a.children && a.children.length > 0
      if(!isGroup) {
        return a.value || a.groupId
      }
    });
    this.props.menus.map((menu, key) => {
      let isGroup = menu.children && menu.children.length > 0;
      if(isGroup) {
        this.refs[menu.groupId].checked = true;
        this.refs['menuSettings-' + menu.groupId].checkAll();
      }
    })
    this.forceUpdate();
  }

  // To mark all element unchecked including children groups
  unCheckAll = () => {
    this.state.value = [];
    this.props.menus.map((menu, key) => {
      let isGroup = menu.children && menu.children.length > 0;
      if(isGroup) {
        this.refs[menu.groupId].checked = false;
        this.refs['menuSettings-' + menu.groupId].unCheckAll();
      }
    })
    this.forceUpdate();
    // this.state.value = null;
  }

  // Set checked value
  setChecked = (val) => {
    this.state.value = val;
    this.forceUpdate();
  }

  state = {
  }

  render = () => {
    return (
      <div className="checkbox-group">
      <CheckboxGroup
        checkboxDepth={3}
        ref="menuGroup"
        value={this.state.value}
        onChange={(_val) => {
          // Setting it back to make sure it reflects the changes
          this.setChecked(_val);
          this.props.onChange(_val);
        }}>
        {this.props.menus.map((menu, key) => {
            if(menu.type === 'divider') {
              return;
            }
            let isGroup = menu.children && menu.children.length > 0;
            return <div key={key}><label className="d-flex text-normal">
              {isGroup &&
                <input type="checkbox" ref={menu.groupId} value={menu.groupId} onChange={(e) => {
                  let _id = 'menuSettings-' + menu.groupId;
                  if(e.target.checked) {
                    this.refs[_id].checkAll();
                  } else {
                    this.refs[_id].unCheckAll();
                  }
                  this.props.onChange([]);
                }}/>
              }
              { !isGroup &&
              <Checkbox value={menu.value || menu.groupId} />
              }
              <span>{menu.label}</span>
              { menu.iconClass &&
              <i className={'tde-m-1 ' + menu.iconClass}></i>
              }</label>
              { isGroup &&
                <ToolbarMenuItems ref={'menuSettings-' + menu.groupId}
                  menus={menu.children} onChange={(_val) => {
                    if(this.refs[menu.groupId]) {
                      this.refs[menu.groupId].checked = this.refs['menuSettings-' + menu.groupId].isAllChecked()
                    }
                    this.props.onChange(_val);
                  }}/> }
              </div>
          })}
      </CheckboxGroup>
      </div>
    )
  }
}

export default ToolbarMenuItems;
